// extracted by mini-css-extract-plugin
export var modal = "_sn-0";
export var table = "_sn-1";